module.exports = __webpack_public_path__ + "media/images/ecalls/metodo_dealer-eabaa01713c5ec05235b91c253234562.png";